import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';

export const MenuWrapper = styled(Box)(({ theme }) => ({
  width: '100vw',
  display: 'flex',
  justifyContent: 'center',
  paddingLeft: 0,
  paddingRight: 0,
}));

export const MenuPaper = styled(Paper)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 2,
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  width: '100%',
  boxShadow: 'none',
  background: 'transparent',
  border: 'none',
})); 